import React from 'react';
import '../styles/library.css';
import DomainChecker from '../photos/Domain_Checker.jpg'
import library from '../utils/library'
import certificate from '../utils/certificate'
import { FaReact } from "react-icons/fa";
import { IoMdArrowDropright } from "react-icons/io";
import { FaGithub } from 'react-icons/fa6';
import { LuLink } from 'react-icons/lu';
import { BiLink } from 'react-icons/bi';
import { Link } from 'react-router-dom';
import Alibaba_clone from '../photos/Alibaba_clone.PNG'
import { motion } from "motion/react"
import { SiPython, SiReact, SiTailwindcss, SiVite } from 'react-icons/si';
import Foot from '../components/Foot';
import SplitText from '../components/extra/TextPressure';

function Library() {
    console.log(library, "luibrary")
    const handleAnimationComplete = () => {
  console.log('All letters have animated!');
};

    return (
             <motion.div  className='library'  initial={{ x: 300, opacity: 0 }} whileInView={{ x: 0, opacity: 1 }} transition={{ duration: 0.1, delay: 0 }} viewport={{ amount: 0, once: true }} >
        <div   initial={{ y: 200, opacity: 0 }} whileInView={{ y: 0, opacity: 1 }} transition={{ duration: 0.1, delay: 0.1 }} viewport={{ amount: 0, once: true }}>
            <div className="library_projects">
                <span>
                    <small style={{ width: '100%', lineHeight: '1px', display: "flex", flexDirection: "column", textAlign: 'center' }}>some selected</small>

                  <SplitText
  text="PROJECTS"
  className="split-parent"
  delay={100}
  duration={0.4}
  ease="power3.out"
  splitType="chars"
  from={{ opacity: 0, y: 50 }}
  to={{ opacity: 1, y: 0 }}
  threshold={0.1}
  rootMargin="10px"
  textAlign="center"
  onLetterAnimationComplete={handleAnimationComplete}
/>  </span>
                <div className="lib_but">{
                    library?.map((lib, index) => {
                        return <motion.div key={index} initial={{ y: 50, opacity: 0 }} whileInView={{ y: 0, opacity: 1 }} transition={{ duration: 0.1, delay: 0.2 }} viewport={{ amount: 0.05, once: true }} className="lib_box"><div className="lbs_mid box"><img src={lib.image} alt="Domain Checker" /></div><div className="lbs_bot">
                            <div className="lbs_bot_left">
                                <div className="lbs_top">{lib.title}</div>
                                <div className="lbsb_mid">{lib.description}</div>
                                <div className="lbsb_bot">
                                    <div className="lbsb_bot_left">
                                        {
                                            lib.icons.map((Icon, index) => {
                                                return <Icon className='lib_icons' key={index} />
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="lbsb_bot_right">
                                {lib.github && <Link className='lbsb_bot_right_sec' to={lib.github} target="_blank" rel="noopener noreferrer"><span style={{ width: '100%', paddingLeft: '10px', display: 'flex', margin: 'auto', flexDirection: 'row', justifyContent: 'space-between' }}><FaGithub /> <section style={{ paddingRight: "5px", paddingLeft: '5px' }}>GitHub code </section><IoMdArrowDropright className='lib_icon' /></span></Link>}
                                {lib.live && <Link className='lbsb_bot_right_sec' to={lib.live} target="_blank" rel="noopener noreferrer"> <span style={{ width: '100%', paddingLeft: '10px', display: 'flex', margin: 'auto', flexDirection: 'row', justifyContent: 'space-between' }}><BiLink /> <section style={{ paddingRight: "5px", paddingLeft: '5px' }}>Live site </section><IoMdArrowDropright className='lib_icon' /></span></Link>}
                            </div>
                        </div>
                        </motion.div>
                    })
                }


                </div>
            </div>
            <div style={{ marginTop: '125px' }} className="library_certificates"> <span>
                <small style={{ width: '100%', lineHeight: '1px', display: "flex", flexDirection: "column", textAlign: 'center' }}>some selected</small>
                <h1>CERTIFICATES</h1></span>
                <div className="lib_but">{
                    certificate?.map((lib, index) => {
                        return <div key={index} className="lib_box">
                            <div className="lbs_mid box"><img src={lib.image} alt="Domain Checker" /></div>
                            <div className="lbs_bot">
                                <div style={{ minHeight: '150px' }} className="lbs_bot_left">
                                    <div className="lbs_top">{lib.title}</div>
                                    <div className="lbsb_mid">{lib.description}</div>
                                    <div className="lbsb_bot">
                                        <div className="lbsb_bot_left">
                                            {
                                                lib.icons.map((Icon, index) => {
                                                    return <Icon className='lib_icons' key={index} />
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="lbsb_bot_right">
                                    <Link className='lbsb_bot_right_sec' to={lib.live}> <span style={{ paddingLeft: '10px' }}><BiLink /> <section style={{ width: '100%', paddingLeft: '10px', display: 'flex', margin: 'auto', flexDirection: 'row', justifyContent: 'space-around' }} target="_blank" rel="noopener noreferrer">Open</section><IoMdArrowDropright className='lib_icon' /></span></Link>
                                </div>
                            </div>
                        </div>
                    })
                }


                </div></div>
            <div className="library_foot"><Foot /></div>
            </div> </motion.div>
       
    )
}

export default Library
